const INITIAL_STATE = {
  error: false,
  loading: null,
  data: [],
  userId: "",
};

const Integration = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "INTEGRATION_REQUEST":
      return { loading: true, error: false, data: [] };
    case "INTEGRATION_ERROR":
      return { loading: false, error: true, data: action.payload };
    case "INTEGRATION_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    case "INTEGRATION_RESET":
      return { loading: false, error: false, data: [] };
    default:
      return state;
  }
};

export default Integration;
